import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, currentRole } from "@/lib/api";
import { DARK_DIALOG, DARK_INPUT, MfaField, inr, errMsg } from "./shared";

export default function RefundDialog({ p, onClose, onDone }) {
  const max = p.amount - (p.refunded_amount || 0);
  const [amount, setAmount] = useState(String(max));
  const [reason, setReason] = useState("");
  const [mfa, setMfa] = useState("");
  const [busy, setBusy] = useState(false);
  const needsMfa = currentRole() === "super_admin";
  const n = parseInt(amount || "0", 10);
  const valid = n >= 1 && n <= max && reason.trim() && (!needsMfa || mfa.length === 6);

  const go = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/manage/payments/${p.id}/refund`, { amount: n, reason, mfa_code: mfa || undefined });
      toast.success(`Refund of ${inr(n)} processed`); onDone();
    } catch (e) { toast.error(errMsg(e, "Refund failed")); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={`${DARK_DIALOG} max-w-md`} data-testid="pm-refund-dialog">
        <DialogHeader>
          <DialogTitle>Refund {p.booking_code}</DialogTitle>
          <DialogDescription className="text-slate-400">Paid {inr(p.amount)} · already refunded {inr(p.refunded_amount)} · refundable <b className="text-slate-200">{inr(max)}</b></DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-semibold text-slate-400">Amount (₹)</label>
            <Input type="number" min={1} max={max} value={amount} onChange={(e) => setAmount(e.target.value)} className={`${DARK_INPUT} font-mono mt-1`} data-testid="pm-refund-amount"/>
            {n > 0 && n < max && <p className="text-[11px] text-amber-400 mt-1">Partial refund</p>}
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-400">Reason (required)</label>
            <Textarea rows={2} value={reason} onChange={(e) => setReason(e.target.value)} className={`${DARK_INPUT} mt-1`} data-testid="pm-refund-reason"/>
          </div>
          {needsMfa && <MfaField value={mfa} onChange={setMfa} testid="pm-refund-mfa"/>}
          <div className="flex justify-end"><Button className="bg-red-600 hover:bg-red-700" disabled={!valid || busy} onClick={go} data-testid="pm-refund-confirm">Process refund</Button></div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
